import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgStyle, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-score-search-bar',
    templateUrl: './score-search-bar.component.html',
    styleUrl: './score-search-bar.component.scss',
    imports: [NgStyle, FormsModule, NgIf]
})
export class ScoreSearchBarComponent {
  @Input() config: { width: number, placeholder: string } = { width: 100, placeholder: 'Search' };
  @Output() onSearch: EventEmitter<string> = new EventEmitter<string>();
  searchValue:string='';
  onSearchChange(event: any): void {
    const trimmedValue = event.value.trim();
    this.onSearch.emit(trimmedValue);
  }
  clearSearch(){
    this.searchValue = ''
    this.onSearch.emit('');
  }
}